import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { SOLUTIONS } from "../../content/solutions";

export const SolutionsList = () => (
  <div className="border-t border-white/15" data-testid="solutions-list">
    {SOLUTIONS.map((s, i) => (
      <Reveal key={s.id} delay={i * 0.05}>
        <Link
          to={`/solutions#${s.id}`}
          data-testid={`solution-card-${s.id}`}
          className="group grid grid-cols-[auto_1fr_auto] items-center gap-5 border-b border-white/15 py-7 md:grid-cols-[80px_1.1fr_1fr_160px_48px] md:gap-8 md:py-9"
        >
          <span className="font-mono text-sm text-[#74DC26]">{s.n}</span>
          <span>
            <span className="font-display block text-2xl md:text-4xl font-medium tracking-tight text-[#F9F8F3] transition-transform duration-500 group-hover:translate-x-2">{s.title}</span>
            <span className="eyebrow mt-2 block !text-[0.6rem] text-[#B4C7BA]">{s.kicker}</span>
          </span>
          <span className="col-span-3 text-sm leading-relaxed text-[#B4C7BA] md:col-span-1">{s.summary}</span>
          <span className="col-span-3 block h-40 overflow-hidden rounded-xl md:col-span-1 md:h-24 md:[clip-path:inset(50%_0_50%_0_round_12px)] md:group-hover:[clip-path:inset(0_0_0_0_round_12px)] md:transition-[clip-path] md:duration-700">
            <img src={s.image} alt="" loading="lazy" className="h-full w-full object-cover" />
          </span>
          <span className="hidden md:grid h-12 w-12 place-items-center rounded-full border border-white/20 text-white transition-colors duration-300 group-hover:bg-[#74DC26] group-hover:text-[#082619]">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </Link>
      </Reveal>
    ))}
  </div>
);
